import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import logo from '../../assets/logo-home-affairs.png';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        image: {
            width: 170
        },
        desc: {
            verticalAlign: 'center',
            marginTop: 25,
            marginLeft: 60,
            marginBottom: 50
        },
        title: {
            marginBottom: 5
        }

    }),
);
const LogoComponent: React.FC = () => {
    const classes = useStyles()




    return (
        <>
            <Grid container direction="row">
                <Grid item>
                    <img src={logo} className={classes.image} alt='' />
                </Grid>
                <Grid item className={classes.desc}>
                    <div className={classes.title}><h1>Screener Verification Portal</h1></div>
                    <h4>Check Accreditation Test Details</h4>
                </Grid>

            </Grid>
        </>
    )
}


export default LogoComponent
